import { Button, createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material';
import { ptBR } from '@mui/material/locale';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

const theme = createTheme(
    {
        palette: {
            primary: {
                light: '#b71c1c',
                main: '#01579b',
                dark: '#bbdefb',
                contrastText: '#fff'
            },
            secondary: {
                light: '#f05545',
                main: '#b71c1c',
                dark: '#7f0000',
                contrastText: '#fff'
            }
        },
        typography: {
            body2: {
                lineHeight: '1'
            },
            h6: {
                fontSize: '18px'
            }
        },
        components: {
            MuiTextField: {
                defaultProps: {
                    variant: 'standard'
                }
            },
            MuiSelect: {
                defaultProps: {
                    variant: 'standard',
                    MenuProps: {
                        style: {
                            zIndex: 1350
                        }
                    }
                }
            },
            MuiTooltip: {
                defaultProps: {
                    arrow: true,
                    disableInteractive: true
                },
                styleOverrides: {
                    tooltip: {
                        fontSize: '11pt',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '600px'
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontWeight: 'bold',
                        '&.Mui-focused': {
                            color: '#01579b',
                            fontWeight: 'bold'
                        }
                    }
                }
            },
            MuiFormControlLabel: {
                styleOverrides: {
                    label: {
                        marginLeft: '8px'
                    }
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        padding: '0px'
                    }
                }
            }
        }
    },
    ptBR
);

const notistackRef = React.createRef();
const onClickDismiss = (key) => (event) => {
    event.stopPropagation();
    if (typeof notistackRef.current.closeSnackbar !== 'undefined') {
        notistackRef.current.closeSnackbar(key);
    }
};

// @ts-ignore
createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <SnackbarProvider
                    ref={notistackRef}
                    maxSnack={4}
                    preventDuplicate={false}
                    classes={{ containerRoot: 'snackbar' }}
                    style={{ whiteSpace: 'pre-line', maxHeight: '400px', overflow: 'auto' }}
                    action={(key) => (
                        <Button
                            onClick={onClickDismiss(key)}
                            style={{ color: 'white' }}
                        >
                            FECHAR
                        </Button>
                    )}
                >
                    <App theme={theme} />
                </SnackbarProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    </React.StrictMode>
);
